import { configureStore } from '@reduxjs/toolkit';

import appReducer from './app';
import authReducer from './auth';
import bankReducer from './bank';
import brandReducer from './brand';
import commonReducer from './common';
import rentalReducer from './rental';
import incomeReducer from './income';
import CountryReducer from './country';
import vehicleReducer from './vehicle';
import bookingReducer from './booking';
import expenseReducer from './expense';
import customerReducer from './customer';
import settingsReducer from './settings';
import dashboardReducer from './dashboard';
import transactionReducer from './transaction';
import balanceSheetReducer from './balanceSheet';

export default configureStore({
  reducer: {
    common: commonReducer,
    auth: authReducer,
    app: appReducer,
    dashboard: dashboardReducer,
    country: CountryReducer,
    brand: brandReducer,
    vehicle: vehicleReducer,
    customer: customerReducer,
    booking: bookingReducer,
    rental: rentalReducer,
    transaction: transactionReducer,
    bank: bankReducer,
    expense: expenseReducer,
    income: incomeReducer,
    balanceSheet: balanceSheetReducer,
    settings: settingsReducer,
  },
});
